import React,{useContext} from 'react'
import styles from './StoreList.module.css'
import Header from './Header';
import OpeningHours from './OpeningHours';
import Food from './Food';
import OtherBrands from './OtherBrands';
import Contact from './Contact';
import Services from './Services';
import Address from './Address';
import { SiteContext } from '../../context/siteContext';

export default function StoreList(props) {

    const {markers} = useContext(SiteContext)
    return (
        <>
            {markers.map(function (marker) {
                return (
                    <div className="col my-2" key={marker.name}>
                        <div className={`card ${styles.card} ${styles.image}`}>
                            <Header name={marker.name} />
                            <h1 className="a pb-5">{marker.name}</h1>
                            <br/>
                            <div className={`${styles.newCard} mx-2`}>
                                <Address address={marker.Address} threeWords={marker.threeWords}/>
                            </div>
                            <br />
                            <div className={`${styles.newCard} mx-2`}>
                                {marker.BusinessHours.Mon_Sat?
                                <OpeningHours open={marker.BusinessHours.Mon_Sat.opens} close={marker.BusinessHours.Mon_Sat.closes} openSun={marker.BusinessHours.Sun.opens} closeSun={marker.BusinessHours.Sun.closes} />
                                    :<OpeningHours everyday={true}/>
                                }
                                {/* <OpeningHours open={marker.BusinessHours.opens} close={marker.BusinessHours.closes} /> */}
                            </div>
                            <br />
                            <div className={`${styles.newCard} mx-2`}>
                                <Contact number={marker.Contact.phoneNumber} email={marker.Contact.emailAddress} />
                            </div>
                            <br />
                            {marker.Contact.name === "Tubbees" ?
                                <>
                                    <div className={`${styles.newCard} mx-2`}>
                                        {marker.utilities.DessertLab ?
                                            <><Food food={marker.utilities.DessertLab} dessertLabOpen={marker.utilities.DessertLab.opens} dessertLabClose={marker.utilities.DessertLab.closes} slushOpen={marker.utilities.Slush.opens} slushClose={marker.utilities.Slush.closes} flavours={marker.utilities.Slush.numberOfFlavours} sitIn={marker.sitIn} takeaway={marker.takeaway} /></>
                                            : <><Food slushOpen={marker.utilities.Slush.opens} slushClose={marker.utilities.Slush.closes} flavours={marker.utilities.Slush.numberOfFlavours} sitIn={marker.sitIn} takeaway={marker.takeaway} /></>}
                                    </div>
                                    <br />
                                </> : <></>
                            }
                            <div className={`${styles.newCard} mx-2`}>
                                <Services services={marker.utilities} />
                            </div>
                            <br />
                            <div className={`${styles.newCard} mx-2`}>
                                <OtherBrands brands={marker.Brands} />
                            </div>
                            <br />
                            {/* <div className={`${styles.left} ${styles.threeWords}`}>
                                <a href={`https://what3words.com/${marker.threeWords}`}>
                                    <div className="my-2 mx-2"><span className={`${styles.threeWordsLogo}`}> /// </span> {marker.threeWords}</div>
                                </a>
                            </div>
                            <br /> */}
                        </div>
                    </div>
                );
            })}
        </>
    )
}
